/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {onboardingInternalRoute} from '../api'

 export const useQueryOnboardingInternalRoute = createReactQueryHook('onboardingInternalRoute', onboardingInternalRoute)
